/// <amd-module name="Test/common-util/TestSummaryReport.Utils" />
import * as TCMContracts from "Test/common-util/Contracts/Test";

export interface PassedTestStatistics {
    passTestRate: number;
    passTestCount: number;
    totalTestCount: number;
    totalNotReportedTestCount: number;
}

export  class TestSummaryReportUtils{
    public static getPassTestRate(aggregatedResult: { [key: number]: TCMContracts.AggregatedResultsByOutcome }): number
    {
        let totalTestsCount = TestSummaryReportUtils.getTotalCount(aggregatedResult);
        const passedTestsCount = aggregatedResult[TCMContracts.TestOutcome.Passed] ? aggregatedResult[TCMContracts.TestOutcome.Passed].count : 0;
        let testsPassRate = (passedTestsCount / totalTestsCount) * 100;
        return testsPassRate;
    }

    public static getPassedTestStatisticsInPipeline(resultSummary: TCMContracts.ResultSummary): PassedTestStatistics
    {
        let PassedTestStatistics: PassedTestStatistics =
        {
            passTestRate: -1,
            passTestCount: 0,
            totalTestCount: 0,
            totalNotReportedTestCount: 0
        }

        if(!!resultSummary.resultSummaryByRunState)
        {
            for (let state of Object.keys(resultSummary.resultSummaryByRunState))
            {
                const resultSummaryByOutcome = resultSummary.resultSummaryByRunState[parseInt(state)];
                if (!!resultSummaryByOutcome && 
                    (parseInt(state) === TCMContracts.TestRunState.Completed || parseInt(state) === TCMContracts.TestRunState.NeedsInvestigation))
                {
                    let result = TestSummaryReportUtils.getPassedTestStatisticsInPipelineByRunState(resultSummaryByOutcome);
                    PassedTestStatistics.passTestCount += result.passTestCount;
                    PassedTestStatistics.totalTestCount += result.totalTestCount;
                    PassedTestStatistics.totalNotReportedTestCount += result.totalNotReportedTestCount;
                }
            }
        }

        if(PassedTestStatistics.totalTestCount > 0)
        {
            PassedTestStatistics.passTestRate = (PassedTestStatistics.passTestCount / PassedTestStatistics.totalTestCount) * 100;
        }

        return PassedTestStatistics;
    }

    private static getPassedTestStatisticsInPipelineByRunState(resultSummary: TCMContracts.ResultsSummaryByOutcome): PassedTestStatistics
    {
        let testCount: PassedTestStatistics =
        {
            passTestRate: 0,
            passTestCount: 0,
            totalTestCount: 0,
            totalNotReportedTestCount: 0
        }

        if(!!resultSummary && !!resultSummary.aggregatedResultDetailsByOutcome)
        {
            let totalNotImpactedTest = resultSummary.aggregatedResultDetailsByOutcome[TCMContracts.TestOutcome.NotImpacted] ? resultSummary.aggregatedResultDetailsByOutcome[TCMContracts.TestOutcome.NotImpacted].count : 0;
            testCount.totalTestCount = resultSummary.totalTestCount - totalNotImpactedTest;
            testCount.passTestCount = resultSummary.aggregatedResultDetailsByOutcome[TCMContracts.TestOutcome.Passed] ? resultSummary.aggregatedResultDetailsByOutcome[TCMContracts.TestOutcome.Passed].count : 0;
            testCount.totalNotReportedTestCount = resultSummary.notReportedTestCount;
        }

        return testCount;
    }

    private static getTotalCount(aggregatedResult: { [key: number]: TCMContracts.AggregatedResultsByOutcome }):number 
    {
        let totalTests = 0; 
        for(let key in aggregatedResult)
        {
           let res: TCMContracts.AggregatedResultsByOutcome =  aggregatedResult[key];
           let count = res.count;
            switch (res.outcome)
                {
                    case TCMContracts.TestOutcome.Passed:
                        totalTests += count;
                        break;
                    case TCMContracts.TestOutcome.Failed:
                        totalTests += count;
                        break;
                    default:
                        totalTests += count;
                        break;
                }
        }
        return totalTests;
    }
}
